import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { addErrorMessage } from '@greenkub-fronts/domain/snackbar';
import { crmFilesAPI } from '@greenkub-fronts/data-access';
import { AppDispatch } from '@greenkub-fronts/shared/interface';

import SignatureSuccess from '../../ui/web/signature-success/signature-success';

export function SignatureSuccessFeature() {
  const { documentId } = useParams();

  const dispatch = useDispatch<AppDispatch>();

  const [documentObjectURL, setDocumentObjectURL] = useState<string>();

  useEffect(() => {
    documentId &&
      crmFilesAPI
        .getDocumentBlobById(documentId)
        .then((respDoc) => {
          setDocumentObjectURL(URL.createObjectURL(respDoc.data));
        })
        .catch((error) => {
          dispatch(
            addErrorMessage(
              "Quelque chose s'est mal déroulé lors du téléchargement de votre document, vous pouvez tenter de recharger la page pour réessayer"
            )
          );
        });
  }, [dispatch, documentId]);

  return <SignatureSuccess documentObjectURL={documentObjectURL} />;
}

export default SignatureSuccessFeature;
